module.exports = require("core-js-pure/stable/instance/slice");